import React from "react";
import { Button } from "@progress/kendo-react-buttons";
import { GridLayout, GridLayoutItem } from "@progress/kendo-react-layout";
import { Field, FieldArrayRenderProps } from "@progress/kendo-react-form";
import { requiredValidator } from "../../components/formFields/CommonValidator";
import {
  CustomAppDialog,
  CustomDialogCloseButton,
} from "../../components/dialog/Dialog";
import { Typography } from "@progress/kendo-react-common";
import { useAppDispatch, useAppSelector } from "../../app/hooks";
import {
  closeGhatApprovalItemDeleteDialog,
  openGhatApprovalItemDeleteDialog,
  setGhatApprovalItemIndex,
} from "./ghatSlice";
import FormNumericTextField from "../../components/formFields/FormNumericTextField";
import { MdDelete } from "react-icons/md";
import IconButton from "../../components/common/IconButton";
import { deleteGhatApprovalItem } from "./services/ghat.services";
import FormSelectionField from "../../components/formFields/FormSelectionField";
import { APPROVAL_TYPE } from "../../_contstants/common";
import { IItem } from "../item/itemModel";
import FormTextArea from "../../components/formFields/FormTextArea";
import { findAllActiveItem } from "../item/services/item.services";
import FormDatePicker from "../../components/formFields/FormDateField";

const ApprovalItemsArray = (fieldArrayRenderProps: FieldArrayRenderProps) => {
  const dispatch = useAppDispatch();
  const GhatApprovalItemIndex = useAppSelector(
    (state) => state.ghat.GhatApprovalItemIndex,
  );
  const UnitList = useAppSelector((state) => state.unit.UnitList);
  const ItemList = useAppSelector((state) => state.item.ItemList);
  const name = fieldArrayRenderProps?.name;
  const GhatApprovalItemDeleteDialog = useAppSelector(
    (state) => state.ghat.GhatApprovalItemDeleteDialog,
  );
  const handleDeleteAction = React.useCallback(
    async (index: number) => {
      if (fieldArrayRenderProps?.value[index].id) {
        const response = await dispatch(
          deleteGhatApprovalItem(fieldArrayRenderProps?.value[index].id),
        );
        if (response.meta.requestStatus === "fulfilled") {
          fieldArrayRenderProps.onRemove({ index: index });
          dispatch(closeGhatApprovalItemDeleteDialog());
          dispatch(setGhatApprovalItemIndex(-1));
        }
      } else {
        fieldArrayRenderProps.onRemove({ index: index });
        dispatch(closeGhatApprovalItemDeleteDialog());
        dispatch(setGhatApprovalItemIndex(-1));
      }
    },
    [fieldArrayRenderProps],
  );
  const pushElementInarray = React.useCallback(() => {
    fieldArrayRenderProps?.onPush({
      value: {
        IssueDate: new Date(),
        type: "",
        item_id: null,
        weight: null,
        qty: null,
        unit_id: null,
        remarks: "",
      },
    });
  }, [fieldArrayRenderProps]);

  const handleOpenDeleteDialog = (index: any) => {
    dispatch(openGhatApprovalItemDeleteDialog());
    dispatch(setGhatApprovalItemIndex(index));
  };

  return (
    <>
      <CustomAppDialog open={GhatApprovalItemDeleteDialog}>
        <>
          <Typography.h5>{"Delete  Approval Item"}</Typography.h5>
          <GridLayout>
            <GridLayoutItem>
              <Typography.p>Are you sure you want to delete this?</Typography.p>
            </GridLayoutItem>
            <GridLayoutItem
              style={{
                display: "flex",
                justifyContent: "end",
              }}
            >
              <CustomDialogCloseButton
                themeColor="error"
                closeDialogFunction={closeGhatApprovalItemDeleteDialog}
              />
              <Button
                fillMode={"solid"}
                themeColor={"error"}
                onClick={() => handleDeleteAction(GhatApprovalItemIndex)}
                type="button"
              >
                Delete
              </Button>
            </GridLayoutItem>
          </GridLayout>
        </>
      </CustomAppDialog>
      <GridLayout cols={[{ width: "50%" }, { width: "50%" }]}>
        <GridLayoutItem>
          <Typography.h5 style={{ margin: 0 }}>Approval Items</Typography.h5>
        </GridLayoutItem>
        <GridLayoutItem style={{ textAlign: "left", marginLeft: "auto" }}>
          <Button
            fillMode={"solid"}
            themeColor={"primary"}
            onClick={pushElementInarray}
            type="button"
          >
            Add Item
          </Button>
        </GridLayoutItem>
      </GridLayout>
      {fieldArrayRenderProps.value &&
        fieldArrayRenderProps.value.length > 0 && (
          <div
            className="table-responsive"
            style={{
              maxHeight: "30vh",
              scrollbarWidth: "thin",
              marginTop: 10,
            }}
          >
            <table
              className="table table-striped table-bordered table-hover field-array-table"
              style={{ minWidth: 1500 }}
            >
              <thead>
                <tr>
                  <th style={{ width: "3%" }}>No</th>
                  <th style={{ width: "12%" }}>Issue Date</th>
                  <th style={{ width: "14%" }}>Type</th>
                  <th style={{ width: "17%" }}>Product Name</th>
                  <th style={{ width: "12%" }}>Weight (gm)</th>
                  <th style={{ width: "12%" }}>Quantity</th>
                  <th style={{ width: "10%" }}>Unit</th>
                  <th style={{ width: "15%" }}>Remarks</th>
                  <th
                    style={{
                      width: "3%",
                      position: "sticky",
                      right: 0,
                      zIndex: 10,
                    }}
                  ></th>
                </tr>
              </thead>
              <tbody>
                {fieldArrayRenderProps.value &&
                  fieldArrayRenderProps.value.length > 0 &&
                  fieldArrayRenderProps.value.map(
                    (approval_items: any, index: number) => (
                      <tr>
                        <td>
                          <Typography.h5
                            style={{
                              margin: "0",
                              textAlign: "center",
                              color: "green",
                            }}
                          >
                            {index + 1}
                          </Typography.h5>
                        </td>
                        <td>
                          <Field
                            name={`${name}.${index}.IssueDate`}
                            component={FormDatePicker}
                            validator={requiredValidator}
                          />
                        </td>
                        <td>
                          <Field
                            name={`${name}.${index}.type`}
                            placeholder="Select Type"
                            component={FormSelectionField}
                            options={APPROVAL_TYPE?.map((type: any) => {
                              return {
                                value: type.value,
                                label: type.label,
                              };
                            })}
                          />
                        </td>
                        <td>
                          <Field
                            name={`${name}.${index}.item_id`}
                            placeholder="Select Item"
                            isAddNew={true}
                            addNewLink="item/create"
                            dispatcherFunction={findAllActiveItem}
                            component={FormSelectionField}
                            options={ItemList?.map((item: IItem) => {
                              return {
                                value: item.id,
                                label: item.item_name,
                              };
                            })}
                          />
                        </td>
                        <td>
                          <Field
                            name={`${name}.${index}.weight`}
                            placeholder="0.000"
                            type="number"
                            format="n3"
                            component={FormNumericTextField}
                            validator={requiredValidator}
                          />
                        </td>
                        <td>
                          <Field
                            name={`${name}.${index}.qty`}
                            placeholder="0.00"
                            type="number"
                            format="n2"
                            component={FormNumericTextField}
                            validator={requiredValidator}
                          />
                        </td>
                        <td>
                          <Field
                            name={`${name}.${index}.unit_id`}
                            placeholder="Select Unit"
                            // isAddNew={true}
                            // isIndirect={true}
                            // isDrawerInDrawer={true}
                            // drawerName="unitForm"
                            // CustomDrawerOpenFunction={openUnitDrawerOpen}
                            validator={requiredValidator}
                            component={FormSelectionField}
                            options={UnitList?.map((unit: any) => {
                              return {
                                value: unit.id,
                                label: unit.unit_name,
                              };
                            })}
                          />
                        </td>
                        <td>
                          <Field
                            rows={1}
                            name={`${name}.${index}.remarks`}
                            placeholder="Write here..."
                            component={FormTextArea}
                          />
                        </td>
                        <td
                          style={{
                            position: "sticky",
                            right: 0,
                            zIndex: 2,
                            backgroundColor: "#f0f0f0",
                            textAlign: "center",
                          }}
                        >
                          <IconButton
                            onClick={() => handleOpenDeleteDialog(index)}
                            // disabled={fieldArrayRenderProps.value.length === 1}
                            themeColor={"error"}
                            size={"small"}
                            fillMode={"solid"}
                            type="button"
                            title="Delete"
                            style={{
                              height: 28,
                              width: 28,
                            }}
                          >
                            <MdDelete
                              className="absolute-position"
                              style={{ fontSize: "16px" }}
                            />
                          </IconButton>
                        </td>
                      </tr>
                    ),
                  )}
              </tbody>
            </table>
          </div>
        )}
    </>
  );
};

export default ApprovalItemsArray;
